// Mapping of universities to their locations (state and city)
export const universityLocations = {
  "Harvard University": { state: "MA", city: "Cambridge" },
  "Stanford University": { state: "CA", city: "Stanford" },
  "Massachusetts Institute of Technology (MIT)": { state: "MA", city: "Cambridge" },
  "Yale University": { state: "CT", city: "New Haven" },
  "Princeton University": { state: "NJ", city: "Princeton" },
  "University of Chicago": { state: "IL", city: "Chicago" },
  "Columbia University": { state: "NY", city: "New York" },
  "University of Pennsylvania": { state: "PA", city: "Philadelphia" },
  "California Institute of Technology (Caltech)": { state: "CA", city: "Pasadena" },
  "Duke University": { state: "NC", city: "Durham" },
  "Northwestern University": { state: "IL", city: "Evanston" },
  "Johns Hopkins University": { state: "MD", city: "Baltimore" },
  "Dartmouth College": { state: "NH", city: "Hanover" },
  "Brown University": { state: "RI", city: "Providence" },
  "Vanderbilt University": { state: "TN", city: "Nashville" },
  "Rice University": { state: "TX", city: "Houston" },
  "Washington University in St. Louis": { state: "MO", city: "St. Louis" },
  "Cornell University": { state: "NY", city: "Ithaca" },
  "University of Notre Dame": { state: "IN", city: "Notre Dame" },
  "University of California, Los Angeles (UCLA)": { state: "CA", city: "Los Angeles" },
  "University of California, Berkeley": { state: "CA", city: "Berkeley" },
  "University of Southern California (USC)": { state: "CA", city: "Los Angeles" },
  "University of Michigan": { state: "MI", city: "Ann Arbor" },
  "University of Virginia": { state: "VA", city: "Charlottesville" },
  "University of North Carolina at Chapel Hill": { state: "NC", city: "Chapel Hill" },
  "New York University (NYU)": { state: "NY", city: "New York" },
  "University of Texas at Austin": { state: "TX", city: "Austin" },
  "University of Washington": { state: "WA", city: "Seattle" },
  "University of California, San Diego (UCSD)": { state: "CA", city: "San Diego" },
  "Boston University": { state: "MA", city: "Boston" },
  "Georgia Institute of Technology": { state: "GA", city: "Atlanta" },
  "University of California, Davis": { state: "CA", city: "Davis" },
  "University of Illinois at Urbana-Champaign": { state: "IL", city: "Urbana" },
  "University of Wisconsin-Madison": { state: "WI", city: "Madison" },
  "Pennsylvania State University": { state: "PA", city: "State College" },
  "Ohio State University": { state: "OH", city: "Columbus" },
  "University of Florida": { state: "FL", city: "Gainesville" },
  "University of California, Santa Barbara": { state: "CA", city: "Santa Barbara" },
  "University of California, Irvine": { state: "CA", city: "Irvine" },
  "Purdue University": { state: "IN", city: "West Lafayette" },
  "University of Maryland": { state: "MD", city: "College Park" },
  "University of Minnesota": { state: "MN", city: "Minneapolis" },
  "University of Pittsburgh": { state: "PA", city: "Pittsburgh" },
  "Rutgers University": { state: "NJ", city: "New Brunswick" },
  "Texas A&M University": { state: "TX", city: "College Station" },
  "Arizona State University": { state: "AZ", city: "Tempe" },
  "University of Colorado Boulder": { state: "CO", city: "Boulder" },
  "Indiana University": { state: "IN", city: "Bloomington" },
  "University of Georgia": { state: "GA", city: "Athens" },
  "University of Connecticut": { state: "CT", city: "Storrs" },
  "University of Delaware": { state: "DE", city: "Newark" },
  "University of Massachusetts": { state: "MA", city: "Amherst" },
  "University of Vermont": { state: "VT", city: "Burlington" },
  "University of Oregon": { state: "OR", city: "Eugene" },
  "University of Utah": { state: "UT", city: "Salt Lake City" },
  "University of Arizona": { state: "AZ", city: "Tucson" },
  "University of South Carolina": { state: "SC", city: "Columbia" },
  "Clemson University": { state: "SC", city: "Clemson" },
  "Virginia Tech": { state: "VA", city: "Blacksburg" },
  "North Carolina State University": { state: "NC", city: "Raleigh" },
  "Florida State University": { state: "FL", city: "Tallahassee" },
  "University of Miami": { state: "FL", city: "Coral Gables" },
  "Tulane University": { state: "LA", city: "New Orleans" },
  "Wake Forest University": { state: "NC", city: "Winston-Salem" },
  "Emory University": { state: "GA", city: "Atlanta" },
  "Georgetown University": { state: "DC", city: "Washington" },
  "Carnegie Mellon University": { state: "PA", city: "Pittsburgh" },
  "University of Rochester": { state: "NY", city: "Rochester" },
  "Brandeis University": { state: "MA", city: "Waltham" },
  "Case Western Reserve University": { state: "OH", city: "Cleveland" },
  "Tufts University": { state: "MA", city: "Medford" },
  "Boston College": { state: "MA", city: "Chestnut Hill" },
  "Lehigh University": { state: "PA", city: "Bethlehem" },
  "Northeastern University": { state: "MA", city: "Boston" },
  "University of California, Riverside": { state: "CA", city: "Riverside" },
  "University of California, Santa Cruz": { state: "CA", city: "Santa Cruz" },
  "University of New Hampshire": { state: "NH", city: "Durham" },
  "University of Maine": { state: "ME", city: "Orono" },
  "University of Rhode Island": { state: "RI", city: "Kingston" },
  "University of Alaska": { state: "AK", city: "Fairbanks" },
  "University of Hawaii": { state: "HI", city: "Honolulu" },
  "University of Nevada, Las Vegas": { state: "NV", city: "Las Vegas" },
  "University of New Mexico": { state: "NM", city: "Albuquerque" },
  "University of Oklahoma": { state: "OK", city: "Norman" },
  "University of Kansas": { state: "KS", city: "Lawrence" },
  "University of Missouri": { state: "MO", city: "Columbia" },
  "University of Arkansas": { state: "AR", city: "Fayetteville" },
  "University of Mississippi": { state: "MS", city: "Oxford" },
  "University of Alabama": { state: "AL", city: "Tuscaloosa" },
  "University of Tennessee": { state: "TN", city: "Knoxville" },
  "University of Kentucky": { state: "KY", city: "Lexington" },
  "University of Louisville": { state: "KY", city: "Louisville" },
  "University of Cincinnati": { state: "OH", city: "Cincinnati" },
  "Wayne State University": { state: "MI", city: "Detroit" },
  "Michigan State University": { state: "MI", city: "East Lansing" },
  "Iowa State University": { state: "IA", city: "Ames" },
  "University of Iowa": { state: "IA", city: "Iowa City" },
  "University of Nebraska": { state: "NE", city: "Lincoln" },
  "Kansas State University": { state: "KS", city: "Manhattan" },
  "Oklahoma State University": { state: "OK", city: "Stillwater" },
  "Texas Tech University": { state: "TX", city: "Lubbock" },
  "University of Houston": { state: "TX", city: "Houston" },
  "Baylor University": { state: "TX", city: "Waco" },
  "Southern Methodist University": { state: "TX", city: "Dallas" },
  "Texas Christian University": { state: "TX", city: "Fort Worth" },
  "University of Denver": { state: "CO", city: "Denver" },
  "Colorado State University": { state: "CO", city: "Fort Collins" },
  "University of Wyoming": { state: "WY", city: "Laramie" },
  "Montana State University": { state: "MT", city: "Bozeman" },
  "University of Montana": { state: "MT", city: "Missoula" },
  "Idaho State University": { state: "ID", city: "Pocatello" },
  "Boise State University": { state: "ID", city: "Boise" },
  "University of Idaho": { state: "ID", city: "Moscow" },
  "Oregon State University": { state: "OR", city: "Corvallis" },
  "Portland State University": { state: "OR", city: "Portland" },
  "Washington State University": { state: "WA", city: "Pullman" },
  "Eastern Washington University": { state: "WA", city: "Cheney" },
  "Western Washington University": { state: "WA", city: "Bellingham" },
  "Central Washington University": { state: "WA", city: "Ellensburg" },
  "Seattle University": { state: "WA", city: "Seattle" },
  "Seattle Pacific University": { state: "WA", city: "Seattle" },
  "UW Bothell": { state: "WA", city: "Bothell" },
  "Bellevue College": { state: "WA", city: "Bellevue" },
  "Shoreline Community College": { state: "WA", city: "Shoreline" },
  "North Seattle College": { state: "WA", city: "Seattle" },
  "South Seattle College": { state: "WA", city: "Seattle" }
};

